import { supabase, getAccessToken } from './supabaseClient';
import { clearAllUserData } from '../data/userDataStore';
import { resetAnalytics } from '../utils/analytics';
import { API_URL } from '../config/api';

// Suppression du compte (App Store, guideline 5.1.1(v) : une app qui permet de
// creer un compte doit permettre de le supprimer depuis l'app).
//
// Le client ne dit jamais QUEL compte supprimer : il envoie son JWT, le serveur
// en deduit l'utilisateur. Lui seul detient la cle de service Supabase, la seule
// qui peut effacer une ligne d'auth.users.
//
// L'achat App Store, lui, n'est pas concerne : il appartient a l'identifiant
// Apple, pas au compte upScale. Il survit a la suppression et se restaure apres
// une nouvelle inscription. Les textes de DeleteAccountDialog le disent, sinon
// on genere des demandes de remboursement.

// Cles locales hors user_data. Le code d'invitation survit normalement a un
// changement de session (cf. lib/beta.js) : il ne doit pas survivre a une
// suppression de compte. La ligne de redemption reste cote serveur, donc
// ressaisir le code plus tard ne consommera pas une seconde place.
const LOCAL_KEYS = [
  'upscale_beta_code',
  'upscale_beta_last_verify',
  'onboardingCompleted',
  'firstTimePopupSeen',
  'hasOpenedBefore',
  'appOpenCount',
  'discoveryTipsSeen',
];

function forgetLocalKeys() {
  for (const key of LOCAL_KEYS) {
    try {
      localStorage.removeItem(key);
    } catch {
      // stockage indisponible : rien a nettoyer
    }
  }
}

export async function deleteAccount(db) {
  const token = await getAccessToken();
  if (!token) throw new Error('no_session');

  const res = await fetch(`${API_URL}/api/auth/account`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    const err = new Error(`account delete HTTP ${res.status}`);
    err.status = res.status;
    throw err;
  }
  const body = await res.json();

  // A partir d'ici le compte n'existe plus : tout ce qui reste en local lui
  // appartient encore et n'a plus de proprietaire.
  await clearAllUserData(db);
  forgetLocalKeys();
  resetAnalytics();

  // scope 'local' : le token vient d'etre invalide avec le compte, un signOut
  // global partirait appeler un /logout qui repondra 401 pour rien.
  try {
    await supabase.auth.signOut({ scope: 'local' });
  } catch {
    // la session locale part de toute facon au rechargement
  }

  return body;
}

export default deleteAccount;
